<template>
  <!-- 编辑新增时 -->
  <template v-if="route.query.type !== 'detail'">
    <el-form
      :model="form"
      :inline="true"
      label-width="120px"
      :rules="rules"
      ref="ruleFormRef"
    >
      <template v-for="(item, index) in formList">
        <template v-if="item.title || item.form">
          <div class="item-title" v-if="item.title" :key="index">
            <el-icon>
              <CaretRight />
            </el-icon>
            {{ item.title }}
          </div>
          <template v-for="(f, fIndex) in item.form">
            <el-form-item
              :key="fIndex"
              :label="f.label"
              :prop="f.value"
              v-if="f.showCondition ? f.showCondition(form) : true"
              :class="
                f.singleLine ? 'el-form-item-100' : 'el-form-item-default'
              "
            >
              <!-- @slot el-form-item内的插槽名  -->
              <slot :name="f.slot" :form="form" v-if="f.slot" />
              <component
                v-else
                v-model="form[f.value]"
                :is="f.component ? f.component : 'el-input'"
                v-bind="f"
                :placeholder="f.placeholder ? f.placeholder : '请输入'"
                :params="f.getParams ? f.getParams(form) : f?.params ?? null"
              >
                <template v-if="f.prepend" #prepend>{{ f.prepend }}</template>
                <template v-if="f.append" #append>{{ f.append }}</template>
              </component>
            </el-form-item>
          </template>
          <template v-if="item.slot">
            <slot :name="item.slot"></slot>
          </template>
        </template>
      </template>
    </el-form>
  </template>
  <!-- 查看详情时 -->
  <template v-else>
    <el-form
      :model="form"
      :inline="true"
      label-width="120px"
      :rules="rules"
      ref="ruleFormRef"
    >
      <template v-for="(item, index) in formList">
        <template v-if="item.title || item.form">
          <div class="item-title" v-if="item.title" :key="index">
            <el-icon>
              <CaretRight />
            </el-icon>
            {{ item.title }}
          </div>
          <template v-for="(f, fIndex) in item.form">
            <el-form-item
              :key="fIndex"
              :label="f.label"
              :prop="f.value"
              v-if="f.showCondition ? f.showCondition(form) : true"
              :class="f.singleLine ? 'el-form-item-100' : 'el-form-item-detail'"
            >
              <!--组件为上传组件时-->
              <template v-if="item.component === 'sUpload'"> </template>
              <template v-else>
                {{
                  f.detailFun
                    ? f.detailFun(form)
                    : form[f.value]
                    ? form[f.value]
                    : "--"
                }}
              </template>
              <!-- <el-image
                    style="width: 100px; height: 100px"
                    :src="url"
                    :zoom-rate="1.2"
                    :preview-src-list="srcList"
                    :initial-index="4"
                    fit="cover"
                    /> -->
            </el-form-item>
          </template>
        </template>
        <template v-if="item.slot">
          <!-- @slot 用户自定义插入el-form-item的插槽名  -->
          <slot :name="item.slot"></slot>
        </template>
      </template>
    </el-form>
    <!-- @slot el-form后插槽名  -->
    <slot></slot>
  </template>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formMixin from "./formMixin";

export default defineComponent({
  name: "sForm",
  components: {},
  mixins: [formMixin],
  emits: {
    /** 详情请求成功后触发
     * @event change
     * @param {object} form 表单
     */
    change: null,
  },
  props: {
    /** 请求详情是默认传参 */
    detailParam: {
      type: String,
      default: "id",
      required: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const ruleFormRef = ref();
    const state = reactive({
      form: {},
      activeName: null,
    });

    const getData = () => {
      if (route.query.type && props.api.detail && route.query.type !== "add") {
        proxy.$api[props.api.detail](
          route.query[props.detailParam],
          "get"
        ).then((res) => {
          const object =
            props.afterGet && props.afterGet(res.data)
              ? props.afterGet(res.data)
              : res.data;
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key)) {
              const element = object[key];
              state.form[key] =
                element && typeof element === "number"
                  ? String(element)
                  : element; //处理后台返回数据和下拉数据类型不一致的问题
            }
          }
          emit("change", state.form);
        });
      }
    };
    onMounted(() => {
      props.formList.forEach((item) => {
        if (item.form && item.form.length > 0) {
          item.form.forEach((f) => {
            if (f.value) {
              state.form[f.value] = f.defaultValue ? f.defaultValue : null;
            }
          });
        }
      });
      getData();
    });
    return {
      ruleFormRef,
      ...toRefs(state),
      route,
    };
  },
});
</script>
<style scoped lang="less">
.item-title {
  height: 22px;
  width: 100%;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
}
</style>
<style lang="less">
.el-form-item-default {
  width: 320px;
  flex-wrap: wrap;
  vertical-align: top !important;

  .el-form-item__label {
    width: 100%;
    display: block;
  }

  .el-form-item__content {
    width: 100%;
    flex: none;

    > div {
      width: 100% !important;
    }
    > span {
      width: 100% !important;
    }
  }
}

.el-form-item-detail {
  width: 320px;
  vertical-align: text-top !important;
}
</style>
<docs lang="md">
### props

###### formList.slot

- 用户自定义插入 el-form-item 的插槽名

###### formList.form item

- @param {string} label - 必传,标签文本
- @param {string} value - 必传,组件 model 的键名
- @param {string} component - 默认为 el-input
- @param {string} slot - el-form-item 内的插槽名
- @param {function} showCondition - 控制 el-form-item,参数为 form
- @param {function} getParams -给 params 传参
- @param element 组件的其他参数
</docs>
